<template>
    <div>
        <template v-if="status.app === 'loaded'">
            <div class="row template-container">
                <div class="col-6">
                    <div class="form template-data-container">
                        <div class="row">
                            <div class="col-10">
                                <div class="row">
                                    <div class="col-6" v-for="(element, index) in form.dynamic_sections">
                                        <div class="form-group">
                                            <label class="form-check-label"
                                                   :for="removeHTMLTags(element.attrs.nombre)">{{
                                                    this.beautifyLabel(element)
                                                }}</label>
                                            <input class="form-check-input" type="checkbox"
                                                   :name="removeHTMLTags(element.attrs.nombre)"
                                                   :id="removeHTMLTags(element.attrs.nombre)"
                                                   :checked="form_json[removeHTMLTags(element.attrs.nombre)] === 'true'"
                                                   @change="fireFormUpdated" @select="fireFormUpdated">
                                        </div>
                                    </div>

                                    <div class="col-6" v-if="Object.keys(form.dynamic_sections).length === 0">
                                        <div class="form-group">
                                            <label class="form-check-label">No hay secciones disponibles</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-2 saving-container">
                                <div class="rounded-btn data-saving" v-if="status.data === 'storing'">
                                    <i class="uq-icon bi-cloud-arrow-down"></i>
                                </div>

                                <div class="rounded-btn data-saved" v-else>
                                    <i class="uq-icon bi-cloud-check"></i>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-6" v-for="(element, index) in form.input_fields">
                                        <div class="form-group">
                                            <label class="form-title"
                                                   :for="element.name">{{ beautifyLabel(element) }}</label>
                                            <input class="form-control" type="text" :name="element.attrs.campo"
                                                   :id="element.attrs.campo"
                                                   :maxlength="200"
                                                   :value="form_json[removeHTMLTags(element.attrs.campo)]"
                                                   @change="fireFormUpdated" @input="fireFormUpdated">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Dynamic attorney and/or lawyer selector. Appears if any lawyer|attorney shortcode exists -->

                            <div class="col-12" v-if="Object.keys(form.attorney).length > 0">
                                <div class="form-group">
                                    <label class="form-title" for="attorney_dropdown_select">Procurador</label>
                                    <select class="form-select" id="attorney_dropdown_select" aria-label="Procurador"
                                            v-model="selected_attorney" @change="updateAttorney">
                                        <option value="" v-if="availableAttorneys[0] === undefined">
                                            No hay procuradores disponibles
                                        </option>

                                        <option :key="attorney.id" :value="attorney.id"
                                                v-for="attorney in availableAttorneys" v-else>
                                            {{ attorney.surname + ", " + attorney.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-12" v-if="Object.keys(form.lawyer).length > 0">
                                <div class="form-group">
                                    <label class="form-title" for="lawyer_dropdown_select">Letrado</label>
                                    <select class="form-select" id="lawyer_dropdown_select" aria-label="Letrado"
                                            v-model="selected_lawyer" @change="updateLawyer">
                                        <option value="" v-if="availableLawyers[0] === undefined">
                                            No hay letrados disponibles
                                        </option>

                                        <option :key="lawyer.id" :value="lawyer.id" v-for="lawyer in availableLawyers"
                                                v-else>
                                            {{ lawyer.surname + ", " + lawyer.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Dynamic attorney and/or lawyer selector. Appears if any lawyer|attorney shortcode exists -->

                            <div class="col-12">
                                <div class="form-group">
                                    <label class="form-check-label" :for="highlight_pdf">Destacar secciones</label>
                                    <input class="form-check-input" type="checkbox" :id="highlight_pdf"
                                           v-model="highlight_pdf"
                                           @change="updatePdfPreview">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6 pdf-data-form-container">
                    <pdf-previewer :src="pdf_preview_content" height="85vh" width="100%"></pdf-previewer>
                </div>
            </div>

            <div class="actions-buttons-section">
                <router-link
                    :to="{name: 'expedient.update', params: {expedient: router.currentRoute.value.params.expedient}}">
                    <button type="button" class="btn btn-secondary rounded-btn" title="Volver al expediente">
                        <i class="uq-icon bi-arrow-left"></i>
                    </button>
                </router-link>

                <div class="buttons-container">
                    <button class="btn btn-outline-danger rounded-btn icon-wrapper" title="Refrescar PDF"
                            @click="applyPdfPreview">
                        <i class="uq-icon bi-arrow-counterclockwise vertical-center"></i>
                    </button>

                    <router-link
                        :to="{name: 'expedient.template.preview', params: {expedient: router.currentRoute.value.params.expedient, template: router.currentRoute.value.params.template}}">
                        <button type="button" class="btn btn-primary rounded-btn" title="Ir al siguiente paso">
                            <i class="uq-icon bi-arrow-right"></i>
                        </button>
                    </router-link>
                </div>
            </div>
        </template>

        <div class="loader-container" v-else>
            <div class="loader"></div>
        </div>
    </div>
</template>

<script>

import router from "../../router";
import {withTimeout} from "../../helpers/requests/RequestsCore";
import PdfPreviewer from "./parts/PdfPreviewer";
import {getTemplate} from "../../helpers/requests/RequestsTemplates";
import {getExpedient, setRelatedAttorney, setRelatedLawyer} from "../../helpers/requests/RequestsExpedients";
import {storeFormValues} from "../../helpers/requests/RequestsFormValues";
import {getAttorneys} from "../../helpers/requests/RequestsAttorneys";
import {getLawyers} from "../../helpers/requests/RequestsLawyers";

export default {
    name: "TemplateDataPage",
    components: {
        PdfPreviewer
    },
    props: {},
    data() {
        return {
            status: {
                app: 'loading',
                data: 'stored',
            },

            expedient: {},
            template: {},
            selected_attorney: 0,
            selected_lawyer: 0,

            availableAttorneys: [],
            availableLawyers: [],

            form: {
                dynamic_sections: [],
                input_fields: [],
                lawyer: [],
                attorney: [],
            },
            form_json: {},

            highlight_pdf: true,
            pagination_pdf: true,

            pdf_preview_content: '',

            timers: {
                preview_pdf: '',
                store_form: '',
            },
        }
    },
    async mounted() {
        await this.loadExpedient();
        await this.loadAvailableAttorneys();
        await this.loadAvailableLawyers();
        await this.loadTemplate();
        this.status.app = 'loaded';
    },
    methods: {
        async loadExpedient() {
            this.expedient = await getExpedient(router.currentRoute.value.params.expedient);
            this.form_json = this.expedient.form_values;

            if (this.expedient.attorneys.length > 0) {
                this.selected_attorney = this.expedient.attorneys[0].id;
            }
            if (this.expedient.lawyers.length > 0) {
                this.selected_lawyer = this.expedient.lawyers[0].id;
            }
        },
        async loadTemplate() {
            this.template = await getTemplate(router.currentRoute.value.params.template);

            await this.updatePdfPreview();

            // Now we detect all those input_fields or sections we need to fulfill the dynamic form
            this.form.dynamic_sections = {};
            this.form.input_fields = {};

            // TODO: Dynamic form from these template shortcodes
            for (let index in this.template.shortcodes_list.original) {
                let shortcode = this.template.shortcodes_list.original[index];
                this.addField(shortcode);
            }
        },
        async loadAvailableAttorneys() {
            this.availableAttorneys = await getAttorneys();
        },
        async loadAvailableLawyers() {
            this.availableLawyers = await getLawyers();
        },
        async updateAttorney() {
            await setRelatedAttorney(router.currentRoute.value.params.expedient, this.selected_attorney);
            await this.loadExpedient();
        },
        async updateLawyer() {
            await setRelatedLawyer(router.currentRoute.value.params.expedient, this.selected_lawyer);
            await this.loadExpedient();
        },
        addField(shortcode) {
            if (shortcode.tag === 'introduce_valor') {
                this.form.input_fields[this.removeHTMLTags(shortcode.attrs.campo)] = shortcode;
            } else if (shortcode.tag === 'seccion') {
                this.form.dynamic_sections[this.removeHTMLTags(shortcode.attrs.nombre)] = shortcode;
                for (let i in shortcode.children) {
                    let child = shortcode.children[i];
                    this.addField(child);
                }
            } else if (shortcode.tag === 'procurador') {
                this.form.attorney[shortcode.attrs.campo] = shortcode;
            } else if (shortcode.tag === 'letrado') {
                this.form.lawyer[shortcode.attrs.campo] = shortcode;
            }
        },
        async updatePdfPreview() {
            this.timers.preview_pdf = withTimeout(async () => {
                await this.applyPdfPreview();
            }, this.timers.preview_pdf, 500);
        },
        async applyPdfPreview() {
            let params = {
                client: this.expedient.clients[0].id,
                entity: this.expedient.entities[0].id,
                expedient: this.expedient.id,
            }
            if (this.expedient.lawyers.length > 0) {
                params.lawyer = this.expedient.lawyers[0].id;
            }
            if (this.expedient.attorneys.length > 0) {
                params.attorney = this.expedient.attorneys[0].id;
            }

            /*let pdf_content = await htmlToPreviewablePdf(this.template.content, params);
            this.pdf_preview_content = "data:application/pdf;base64," + escape(pdf_content);*/
            let destination_route = window.location.origin + this.$router.resolve({
                name: 'pdf.preview',
                params: {expedient: params.expedient, template: router.currentRoute.value.params.template},
            }).fullPath;

            let highlight_param = '';
            if (this.highlight_pdf === true) {
                highlight_param = 'highlight=true&';
            }

            this.pdf_preview_content = destination_route + '?' + highlight_param + 'parse=true';

            document.getElementById('pdf_iframe').src = this.pdf_preview_content;
        },
        fireFormUpdated(e) {
            let name = e.target.name;
            let value = e.target.value;

            if (e.target.type === 'checkbox') {
                // As string to be stored in form_values table
                value = e.target.checked + "";

                // TODO: Activate or deactivate the other dynamic sections
                if (value === 'true') {
                    if (!!this.form.dynamic_sections[name].attrs.activa) {
                        // Activate those that are activated by this one
                        let sections_to_activate = this.removeHTMLTags(this.form.dynamic_sections[name].attrs.activa).split(',');
                        for (let i in sections_to_activate) {
                            let section_to_activate = sections_to_activate[i];
                            this.form_json[section_to_activate] = 'true';
                        }
                    }
                } else if (value === 'false') {
                    if (!!this.form.dynamic_sections[name].attrs.desactiva) {
                        // Deactivate those that are deactivated by this one
                        let sections_to_deactivate = this.removeHTMLTags(this.form.dynamic_sections[name].attrs.desactiva).split(',');
                        for (let i in sections_to_deactivate) {
                            let section_to_deactivate = sections_to_deactivate[i];
                            this.form_json[section_to_deactivate] = 'false';
                        }
                    }
                }
            }

            if (!!value) {
                this.form_json[name] = value;
            } else {
                // We delete it to be deleted on database
                delete this.form_json[name];
            }

            this.storeFormValuesWithTimeout();
        },
        beautifyLabel(label) {
            // Review this...
            if (!!label.attrs && !!label.attrs.nombre) {
                label = label.attrs.nombre;
            } else if (!!label.attrs && !!label.attrs.campo) {
                label = label.attrs.campo;
            }

            try {
                return this.removeHTMLTags(label.charAt(0).toUpperCase() + label.slice(1).replaceAll('_', ' '));
            } catch (e) {
                alert('El shortcode de nombre ' + label.tag + ' está dando problemas...');
            }
        },
        removeHTMLTags(text) {
            // Use this to store or load or refer something, the display message can be
            let tmp = document.createElement("DIV");
            tmp.innerHTML = text;
            return tmp.textContent || tmp.innerText || "";
        },
        storeFormValuesWithTimeout() {
            this.status.data = 'storing';
            this.timers.store_form = withTimeout(async () => {
                await storeFormValues({...this.form_json}, router.currentRoute.value.params.expedient);
                this.status.data = 'stored';
                // Once stored, update pdf preview
                await this.applyPdfPreview();
            }, this.timers.store_form, 500);
        }
    },
    setup() {
        return {
            router,
        }
    }
}
</script>
